/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Profile_SectionInputs */

const vi_grower_profile_section = /** @type {(inputs: Grower_Profile_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin hồ sơ`)
};

/**

* @param {Grower_Profile_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_profile_section = /** @type {((inputs?: Grower_Profile_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Profile_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_profile_section(inputs)
});